export enum OrderSideEnum {
    Compra = 49,
    Venda = 50,
    CompraAdvice = "C",
    VendaAdvice = "V"
}